import { ParsedUrlQuery } from "querystring";
import { VariantGroup } from "@/types/types.ts";
import { filterQueryParams } from "@/utils/url/filterQueryParams";

export function createVariantGroupUrlObj(
  variantGroup: VariantGroup,
  query: ParsedUrlQuery,
) {
  const queryParams = filterQueryParams(query);

  return {
    pathname: variantGroup.pdpURL.path,
    query: { ...queryParams },
  };
}
